import {ComboboxItem, ComboboxProvider, SelectProvider} from '@ariakit/react'
import {
    SelectComboboxInput,
    SelectComboboxList,
    SelectComboboxPopover,
    SelectTrigger,
    SelectVirtualList
} from '@components/ui/select-atoms/SelectAtoms.tsx'
import {StyledSelectItem} from '@components/commons/multi-select-checkbox/style.ts'
import {Checkbox} from '@components/commons/checkbox/ChekBox.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {InputHelpText} from '@components/ui/input-help-text/InputHelpText.tsx'
import {Skeleton} from '@components/ui/skeleton/Skeleton.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {useInfinitePatients} from '@/features/patients/services/useInfinitePatients'

interface PatientFilterMultiSelectProps {
    value: string[]
    onChange: (value: string[]) => void
}

export const PatientFilterMultiSelect: FC<PatientFilterMultiSelectProps> = ({value, onChange}) => {
    const {t} = useTranslation()
    const patientsQuery = useInfinitePatients({
        limit: 100
    })

    return (
        <ComboboxProvider setValue={patientsQuery.onSearch} resetValueOnHide>
            <SelectProvider setValue={onChange} value={value} defaultValue={[]}>
                <SelectTrigger
                    displayValue={value => t('commons:x_selected', {count: value.length})}
                    placeholder={t('table_filters:select_value')}
                />
                <SelectComboboxPopover style={{width: '360px'}} sameWidth={false}>
                    <SelectComboboxInput />
                    <SelectComboboxList>
                        {patientsQuery.isLoading ? (
                            <Flexbox direction="column" gap={1}>
                                {Array.from({length: 6}, (_, index) => (
                                    <Skeleton key={index} height={32} />
                                ))}
                            </Flexbox>
                        ) : patientsQuery.isError ? (
                            <InputHelpText error={t('errors:default')} />
                        ) : patientsQuery.remappedData.length == 0 ? (
                            <InputHelpText helpText={t('commons:no_results')} />
                        ) : (
                            <SelectVirtualList
                                data={patientsQuery.remappedData}
                                totalCount={patientsQuery.remappedData.length}
                                overscan={100}
                                endReached={patientsQuery.fetchNextPage}
                                itemContent={(_, patient) => (
                                    <StyledSelectItem
                                        render={<ComboboxItem />}
                                        value={patient.id}
                                        key={patient.id}
                                        selectItemContentClassName="content"
                                    >
                                        {patient.fullName}
                                        <Checkbox
                                            id="selected"
                                            checked={value.includes(patient.id)}
                                            onChange={() => undefined}
                                        />
                                    </StyledSelectItem>
                                )}
                            />
                        )}
                    </SelectComboboxList>
                </SelectComboboxPopover>
            </SelectProvider>
        </ComboboxProvider>
    )
}
